import { Component, OnInit } from '@angular/core';
import {SeoService} from '../../../../services/seo/seo.service';

@Component({
  selector: 'app-eco-social-stu-society',
  templateUrl: './eco-social-stu-society.component.html',
  styleUrls: ['./eco-social-stu-society.component.scss']
})
export class EcoSocialStuSocietyComponent implements OnInit {

  constructor(private seo: SeoService) { }

  ngOnInit(): void {
    this.seo.setMeta('Society of Economics and Social Statistics');
  }

}
